import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { IResponse } from "../../interfaces/IResponse";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { apiOfflineAsync } from 'src/app/layouts/pages/pages.component';

@Injectable({
  providedIn: 'root'
})
export class PrecificacaoService {
  parameters: any = {}
  API_PATH: string
  isXls: boolean = false;
  isJson: boolean = false

  private ngUnsubscribe: Subject<void> = new Subject<void>()

  requestOptionsFormData: any = new HttpHeaders({ 'Content-Type': 'multipart/form-data' })

  private requestOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private httpClient: HttpClient,
  ) {
    this.API_PATH = environment.apiUrl;
  }

  getArrayTableUuid(parameters: any): Observable<IResponse> {
    let url = `${this.API_PATH}pricing/organization/${parameters.corporation_uuid}`
    this.ngUnsubscribe.next()
    return this.httpClient.get<IResponse>(url).pipe(takeUntil(this.ngUnsubscribe));
  }

  async setTableUuid(body: any, uuid: any = null) {
    return await this.httpClient.post<IResponse>(
      `${this.API_PATH}pricing`,
      body,
      this.requestOptionsFormData
    ).toPromise();
  }

  getLogsUuid(parameters: any): Observable<IResponse> {
    let url = `${this.API_PATH}pricing/organization-taxes-logs/${parameters.corporation_uuid}`
    this.ngUnsubscribe.next()
    return this.httpClient.get<IResponse>(url).pipe(takeUntil(this.ngUnsubscribe));
  }

  async setLogUuid(body: any, uuid: any = null) {
    return await this.httpClient.post<IResponse>(
      `${this.API_PATH}pricing/organization-taxes`,
      body,
      this.requestOptionsFormData
    ).toPromise();
  }
}
